import update from 'react/lib/update';
//import { reverse } from 'lodash';

const initialState = {
	isFetching: false,
	documents: [],
	filter: { sectors: [], localities: [], samplingPoints: [], keywords: [], ids: null },
	layers: [],
	isFetchingMapLayers: false,
	maplayers: [],
	showLegend: false,
	hideDocumentsFromMap: false,
	selected: []
};

export default function explorer(state = initialState, action) {
	
	switch (action.type) {

		case "IS_FETCHING_EXPLORER":
			return update(state, { isFetching: { $set: action.bool } });
		
		case "IS_FETCHING_EXPLORER_MAPLAYERS":
			return update(state, { isFetchingMapLayers: { $set: action.bool } });

		case "SET_FILTER_SECTORS":
			return update(state, { filter: { sectors: { $set: action.sectors } } });

		case "SET_FILTER_LOCALITIES":
			return update(state, { filter: { localities: { $set: action.localities } } });

		case "SET_FILTER_SAMPLING_POINTS":
			return update(state, { filter: { samplingPoints: { $set: action.samplingPoints } } });

		case "SET_FILTER_KEYWORDS":
			return update(state, { filter: { keywords: { $set: action.keywords } } });

		case "SET_FILTER_IDS":
			return update(state, { filter: { ids: { $set: action.ids } } });

		case "SET_EXPLORER_DOCUMENTS":
			return update(state, { documents: { $set: action.documents } });

		case "SET_EXPLORER_SELECTED_DOCUMENTS":
			return update(state, { selected: { $set: action.selected } });

		case "ADD_EXPLORER_LAYER":
			// Add always on first position
			const layers = [action.layer].concat(state.layers);
			return update(state, { layers: { $set: layers } });

		case "REMOVE_EXPLORER_LAYER":
			const idLayerToRemove = action.id;
			let visibleLayers = state.layers;

			let newVisibleLayers = visibleLayers.filter((obj) => { return obj.id !== idLayerToRemove; });

			return update(state, { layers: { $set: newVisibleLayers } });

		case "MOVE_EXPLORER_LAYER":
			return update(state, { layers: { $splice: [
				[action.dragIndex, 1], 
				[action.hoverIndex, 0, action.layer] 
			]}});

		case "RESET_EXPLORER_LAYERS":
			return update(state, { layers: { $set: [] } });

		case "SET_SHOW_LEGEND":
			return update(state, { showLegend: { $set: action.bool } });
		
		case "SET_HIDE_DOCUMENTS_FROM_MAP":
			return update(state, { hideDocumentsFromMap: { $set: action.bool } });
		
		case "SET_MAP_LAYERS":
			return update(state, { maplayers: { $set: action.mapLayers } });
		
		case "SET_ONE_MAP_LAYER":
			const _maplayer = state.maplayers;
			searchAndSetPropertyInListTree(_maplayer, action.id, action.openOrCheck);
			return update(state, { maplayers: { $set: _maplayer } });

		default:
			return state;
	}
}

export const groupTitles = (documents) => {
	const dict = {};
	documents.map((d) => {
		d.position
			.filter((p) => p.type === 4 || p.type === 6)
			.map((p) => {
				if ( typeof dict[p.shapeId] === "undefined" ) dict[p.shapeId] = [];
				if ( dict[p.shapeId].indexOf(d.title) === -1 ) dict[p.shapeId].push(d.title);
			});
	});
	return dict;
};

export const groupDocuments = (documents) => {
	const dict = {};
	documents.map((d) => {
		d.position			
			.map((p) => {
				if ( typeof dict[p.shapeId] === "undefined" ) dict[p.shapeId] = [];
				if ( dict[p.shapeId].indexOf(d.id) === -1 ) dict[p.shapeId].push(d.id);				
			});
	});
	return dict;
};

function searchAndSetPropertyInListTree(element, matchingId, openOrCheck) {
	if (element instanceof Array) {
		for (let elem of element) {
			searchAndSetPropertyInObjectTree(elem, matchingId, openOrCheck);
		}
	} else {
		searchAndSetPropertyInObjectTree(element, matchingId, openOrCheck);
	}
}

function searchAndSetPropertyInObjectTree(element, matchingId, openOrCheck) {
	if (element.id === matchingId) {
		element.openOrCheck = openOrCheck;
	} else if (element.children != null) {
		var i;
		var result = null;
		for (i=0; result == null && i < element.children.length; i++) {
			result = searchAndSetPropertyInObjectTree(element.children[i], matchingId, openOrCheck);
		}
		return result;
	}
	return null;
}




// WEBPACK FOOTER //
// ./src/state/explorer/reducer.js